import { axiosObjectTypesense } from "../typesenseConfig";

export default function getSearchResultsWithPaginationForPrivate(
  payload: any,
  itemsPerPage = 48,
  page: any
) {
  return new Promise((resolve, reject) => {
    let uri = `multi_search?x-typesense-api-key=${process.env.NEXT_PUBLIC_PRIVATE_PROPERTY_SEARCH_KEY}`;

    // Modify the payload to include pagination parameters
    const paginatedPayload = {
      ...payload,
      searches: payload.searches.map((search: any) => ({
        ...search,
        per_page: itemsPerPage,
        page: page,
      })),
    };

    axiosObjectTypesense
      .post(uri, paginatedPayload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
